import React from 'react';
import { Box } from '@mui/material';
import { AdditionalInfoTab } from '../wizard/AdditionalInfoTab';
import { PrivateOnlyBanner } from '../../components/edit-object/PrivateOnlyBanner';

interface StepProps {
  catalogItemId?: string;
  ownerId?: string | null;
}

/**
 * Renders private-only fields (notes, physical location, estimated value)
 * behind a PrivateOnlyBanner that makes the never-shown-publicly contract
 * explicit. Inventory number, keywords, and collections moved out to the
 * dedicated Catalog & Keywords step because those fields aren't strictly
 * private.
 */
export const PrivateOnlyStep: React.FC<StepProps> = ({ catalogItemId, ownerId }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    <PrivateOnlyBanner />
    <AdditionalInfoTab
      catalogItemId={catalogItemId}
      ownerId={ownerId}
      hidePublicNotes
      splitPrivateSections
    />
  </Box>
);
